import { render, staticRenderFns } from "./CompanyVariablesList.vue?vue&type=template&id=74f1d97e&scoped=true"
import script from "./CompanyVariablesList.vue?vue&type=script&lang=js"
export * from "./CompanyVariablesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f1d97e",
  null
  
)

export default component.exports